/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FocusedPlayers } from '../models/FocusedPlayers';
import type { ManOfTheMatch } from '../models/ManOfTheMatch';
import type { ManOfTheMatchVote } from '../models/ManOfTheMatchVote';
import type { PlayerListElementList } from '../models/PlayerListElementList';
import type { TeamOfTheWeekLineup } from '../models/TeamOfTheWeekLineup';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ManOfTheMatchService {
    /**
     * Get Team Of The Week
     * @param leagueId
     * @param matchDay
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getTeamOfTheWeekManOfTheMatchTeamLeagueIdMatchdayMatchDayGet(
        leagueId: number,
        matchDay: number,
    ): CancelablePromise<(TeamOfTheWeekLineup | null)> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/man_of_the_match/team/{league_id}/matchday/{match_day}',
            path: {
                'league_id': leagueId,
                'match_day': matchDay,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Man Of The Match Voting By Match
     * @param matchId
     * @returns ManOfTheMatch Successful Response
     * @throws ApiError
     */
    public static getManOfTheMatchVotingByMatchManOfTheMatchMatchIdGet(
        matchId: number,
    ): CancelablePromise<ManOfTheMatch> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/man_of_the_match/{match_id}',
            path: {
                'match_id': matchId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Vote Match
     * @param requestBody
     * @returns ManOfTheMatch Successful Response
     * @throws ApiError
     */
    public static voteMatchManOfTheMatchPost(
        requestBody: ManOfTheMatchVote,
    ): CancelablePromise<ManOfTheMatch> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/man_of_the_match/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Focused Players Both Teams
     * @param matchId
     * @param limitPlayers
     * @param amountMatches
     * @returns FocusedPlayers Successful Response
     * @throws ApiError
     */
    public static getFocusedPlayersBothTeamsManOfTheMatchFocusBothTeamsMatchIdGet(
        matchId: number,
        limitPlayers: number,
        amountMatches: number,
    ): CancelablePromise<FocusedPlayers> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/man_of_the_match/focus/both-teams/{match_id}',
            path: {
                'match_id': matchId,
            },
            query: {
                'limit_players': limitPlayers,
                'amount_matches': amountMatches,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Focused Players
     * @param matchId
     * @param teamId
     * @param limitPlayers
     * @param amountMatches
     * @returns PlayerListElementList Successful Response
     * @throws ApiError
     */
    public static getFocusedPlayersManOfTheMatchFocusMatchIdGet(
        matchId: number,
        teamId: number,
        limitPlayers: number,
        amountMatches: number,
    ): CancelablePromise<PlayerListElementList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/man_of_the_match/focus/{match_id}',
            path: {
                'match_id': matchId,
            },
            query: {
                'team_id': teamId,
                'limit_players': limitPlayers,
                'amount_matches': amountMatches,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
